import React from 'react';
import { Create } from 'react-admin';
import { t } from 'i18next';

import CustomCreateToolbar from '../CustomCreateToolbar';
import { SizeClassMixForm } from './SizeClassMixForm';

export const SizeClassMixCreate = props => (
  <Create {...props} title={t('size_class_mix.title_create')}>
    <SizeClassMixForm toolbar={<CustomCreateToolbar user={props.options.currentUser.role}/>}/>
  </Create>
);